import { render, staticRenderFns } from "./tenthMobile.vue?vue&type=template&id=99a1faaa&scoped=true"
import script from "./tenthMobile.vue?vue&type=script&lang=js"
export * from "./tenthMobile.vue?vue&type=script&lang=js"
import style0 from "./tenthMobile.vue?vue&type=style&index=0&id=99a1faaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a1faaa",
  null
  
)

export default component.exports